import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from './lib/apollo';
import { I18nProvider } from './providers/I18nProvider';
import KeyboardShortcutsProvider from './components/KeyboardShortcutsProvider';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import './styles/index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ApolloProvider client={apolloClient}>
        <I18nProvider>
          <BrowserRouter>
            <KeyboardShortcutsProvider>
              <App />
            </KeyboardShortcutsProvider>
          </BrowserRouter>
        </I18nProvider>
      </ApolloProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

